import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TourIcon(props: IconProps) {
    return <Icon {...props} iconKey={"tour"}/>
}
